import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-dialog',
  templateUrl: 'dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogModule, MatButtonModule],
})
export class PromptDialogComponent {
  public dialogRef = inject(MatDialogRef<PromptDialogComponent>);
  public data = inject(MAT_DIALOG_DATA);

  close(res: unknown): void {
    this.dialogRef.close(res);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
